import { render, staticRenderFns } from "./CSmsErrorComp.vue?vue&type=template&id=e5d871f6&"
import script from "./CSmsErrorComp.vue?vue&type=script&lang=js&"
export * from "./CSmsErrorComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports